import { render, staticRenderFns } from "./requestMessage.vue?vue&type=template&id=1392dc9d&scoped=true"
import script from "./requestMessage.vue?vue&type=script&lang=js"
export * from "./requestMessage.vue?vue&type=script&lang=js"
import style0 from "./requestMessage.vue?vue&type=style&index=0&id=1392dc9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1392dc9d",
  null
  
)

export default component.exports